import { ApiRequestPayload, Callback, ExtraAction, apiCall, apiRequestDefaultPayload } from '..';
import { customerIsLogged, getCurrentUserBySessionKey } from '../../../../utils/authenticated-user';

export const findVentureForMapById = (
  ventureId: number,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const isCustomer = customerIsLogged();
  const customer = getCurrentUserBySessionKey('customer');
  console.debug('findVentureForMapById', customer);
  const { customerId } = isCustomer ? customer : { customerId: null };
  const apiPath = isCustomer
    ? `/api/public/ventures/${ventureId}?customerId=${customerId}`
    : `/api/public/ventures/${ventureId}`;
  console.log(`apiPath`, apiPath);
  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: apiPath,
    onSuccess: successActionName,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};

export const findVentureBatchById = (
  batchId: number,
  customerId: number | null | undefined,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const apiPath = customerId
    ? `/api/public/batches/${batchId}/details?customerId=${customerId}`
    : `/api/public/batches/${batchId}/details`;

  console.log(`findVentureBatchById apiPath`, apiPath);
  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: apiPath,
    onSuccess: successActionName,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};

export const sendIntention = (
  data: object,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const apiPath = `/api/public/batches/intentions`;

  console.log(`sendIntention apiPath`, apiPath);

  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));

  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    method: 'POST',
    data,
    url: apiPath,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};

export const sendReservation = (
  data: object,
  callbacks?: Array<Callback> | null,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const apiPath = `/api/public/batches/reserve`;

  console.log(`sendReservation apiPath`, apiPath, data);

  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));

  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    method: 'POST',
    data,
    url: apiPath,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};

export const sendSimulation = (
  data: object,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const apiPath = `/api/public/batches/simulate`;

  console.log(`sendSimulation apiPath`, apiPath, data);

  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));

  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    method: 'POST',
    data,
    url: apiPath,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};
